import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Button, SxProps, Theme, Typography } from '@mui/material';

import { TestBoosterBanner } from './TestBoosterBanner';
import { boosterPageSx } from '../satActBooster.styles';

const STRINGS = appStrings.modules.satActBooster.loadError;

type BoosterLoadErrorProps = Readonly<{
  onRetry: () => void;
}>;

/** Full-page error state for a failed most-recent fetch, distinct from the empty state. */
export const BoosterLoadError = ({ onRetry }: BoosterLoadErrorProps) => (
  <Box sx={boosterPageSx}>
    <TestBoosterBanner />
    <Box sx={contentSx}>
      <Typography variant="text-lg-semibold">{STRINGS.title}</Typography>
      <Typography variant="text-sm-regular" sx={bodySx}>
        {STRINGS.body}
      </Typography>
      <Button
        id="booster-load-error-retry"
        variant="contained"
        size="lg"
        hierarchy="Primary"
        onClick={onRetry}
      >
        {STRINGS.retry}
      </Button>
    </Box>
  </Box>
);

const contentSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: backrs.spacing['spacing-lg'],
  paddingTop: backrs.spacing['spacing-8xl'],
});

const bodySx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
